// Material inquiry
import {getQuery, isEmpty, isNotEmpty} from "../../tools/utils";
import API from "../../apis";

let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableSet = {
    tableSet:{
        row_key:'id',
        tab: 'xmxx',
        table_class: 'layout-table',
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: false,
        selected: [],
        selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'VBELN',field: 'VBELN',label: '特价单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'VBELN',field: 'VBELN',label: '价单号/销售订单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FBillNo',field: 'FBillNo',label: '采购订单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'VKORG',field: 'VKORG',label: '销售组织',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'VTWEG',field: 'VTWEG',label: '销售渠道',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'SPART',field: 'SPART',label: '销售产品组',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ERNAM',field: 'ERNAM',label: '创建人',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'BSTDK',field: 'BSTDK',label: '创建时间',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ERDAT',field: 'ERDAT',label: '报价日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KUNNR',field: 'KUNNR',label: '订货人',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KGNNR',field: 'KGNNR',label: '收货人',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME1',field: 'NAME1',label: '收货人地址名称1',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME2',field: 'NAME2',label: '收货人地址名称2',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'POSTL_COD1',field: 'POSTL_COD1',label: '收货人邮政编码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CITY1',field: 'CITY1',label: '收货人城市',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ZZPROM',field: 'ZZPROM',label: '三方协议号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'BSTKD',field: 'BSTKD',label: '特折号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'AUART',field: 'AUART',label: '订单/报价单类型',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NETWRH',field: 'NETWRH',label: '整单不含税金额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'MWSTH',field: 'MWSTH',label: '整单税额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'WAERK',field: 'WAERK',label: '销售订单货币单位',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'DPFLAG',field: 'DPFLAG',label: '预付款标志',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ITEM_DATA',field: 'ITEM_DATA',label: '项目信息',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CODE',field: 'CODE',label: '状态码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MESSAGE',field: 'MESSAGE',label: '状态提示',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'BATCH',field: 'BATCH',label: '单据批次',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'TOTAL',field: 'TOTAL',label: '项目行数',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CREATE_CODE',field: 'CREATE_CODE',label: '生成状态',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CREATE_DATETIME',field: 'CREATE_DATETIME',label: '生成时间',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: [
                {
                    sign: 'createEoder',
                    index: 1,
                    name: '生成电子订单',
                    icon: 'fas fa-plus'
                },
                {
                    sign: 'clearState',
                    index: 1,
                    name: '清除生成状态',
                    icon: 'fas fa-plus'
                },
                // {
                //     sign: 'showDetails',
                //     index: 1,
                //     name: '特价单详情',
                //     icon: 'fas fa-plus'
                // },
                // {
                //     sign: 'batch-inquiry',
                //     index: 1,
                //     name: '导出',
                //     icon: 'fas fa-plus'
                // }
            ]
        }
    },
    entryTableSet:{
        row_key:'ID',
        table_class: 'layout-table',
        loading:false,
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: true,
        selected: [],
        selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'POSNR',field: 'POSNR',label: '行号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'UEPOS',field: 'UEPOS',label: '高阶行号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MATNR',field: 'MATNR',label: '订货号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KWMENG',field: 'KWMENG',label: '数量',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'VRKME',field: 'VRKME',label: '数量单位',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'EDATU',field: 'EDATU',label: '客户期望交货日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CDATE',field: 'CDATE',label: '承诺日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MWSTI',field: 'MWSTI',label: '税额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'NETWRI',field: 'NETWRI',label: '不含税金额',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'WAERK_I',field: 'WAERK_I',label: '销售订单行货币单位',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'WERKS',field: 'WERKS',label: '出货物流中心',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ZZCRDDATE',field: 'ZZCRDDATE',label: '客户要求货期（原始）',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KGNNR_I',field: 'KGNNR_I',label: '行项目收货人',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME1_I',field: 'NAME1_I',label: '行项目收货人地址名称1',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'NAME2_I',field: 'NAME2_I',label: '行项目收货人地址名称2',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'POSTL_COD1_I',field: 'POSTL_COD1_I',label: '行项目收货人邮政编码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CITY1_I',field: 'CITY1_I',label: '行项目收货人城市',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'CUSTOMIZED_LABEL',field: 'CUSTOMIZED_LABEL',label: '打标信息',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'ITEM_PRICING',field: 'ITEM_PRICING',label: '价格条件信息',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: []
        }
    },
    priceTableSet:{
        row_key:'ID',
        table_class: 'layout-table',
        loading:false,
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: true,
        selected: [],
        selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'POSNR',field: 'POSNR',label: '行号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KSCHL',field: 'KSCHL',label: '价格类型',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'VTEXT',field: 'VTEXT',label: '描述',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KBETR',field: 'KBETR',label: '值',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'KWERT',field: 'KWERT',label: '金额',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: []
        }
    },
}
const state = ()=>({
    specialOffer:Object.assign({},tableSet)
})
const getters = {
    getTable:state => state.specialOffer.tableSet,
    getEntryTable :state => state.specialOffer.entryTableSet,
    getPriceTable :state => state.specialOffer.priceTableSet,
}
const mutations = {
    ['setTab'](state, data) {
        state.specialOffer.tableSet.tab = data;
    },  
    ['setResetFun'](state, data) {
        state.specialOffer.tableSet.resetFun = data;
    },
    ['clearSelected'](state, data) {
        state.specialOffer.tableSet.selected = [];
    },
    ['setList'](state, data) {
        state.specialOffer.tableSet.data = data.data.data;
        data.data.data.forEach(item => {
            if(isNotEmpty(item.ID) && !isNotEmpty(item.id)){
                item.id = item.ID;
            }
        });
        state.specialOffer.tableSet.selected = !isEmpty(data.data.data)  ? [data.data.data[0]] : [];
        state.specialOffer.tableSet.pagination.count = data.data.count;
    },
    ['setEntryList'](state, data) {
        state.specialOffer.entryTableSet.data = data.data;
    },
    ['setPriceList'](state, data) {
        state.specialOffer.priceTableSet.data = data.data;
    },
    ['clearList'](state, data) {
        state.specialOffer.tableSet.data = []
        state.specialOffer.tableSet.pagination.count = 0;
    },
    ['clearEntryList'](state, data) {
        state.specialOffer.entryTableSet.data = []
        state.specialOffer.entryTableSet.pagination.count = 0;
        state.specialOffer.priceTableSet.data = []
        state.specialOffer.priceTableSet.pagination.count = 0;
    },
    ['setTableHeight'](state, data){
        let height = (data/2)+29
        state.specialOffer.tableSet.height = height + 'px';
        state.specialOffer.entryTableSet.height = height + 'px';
        state.specialOffer.priceTableSet.height = height + 'px';
    },
}
const actions = {
    ['clearState']({ state, commit ,dispatch},payload) {
        if (state.specialOffer.tableSet.loading == true) return;
        let msg = {
            event: "command",
            data: {
                run: "delete_order_tag",  //需要获取的数据方法
                query:{sprno: payload}             //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        state.specialOffer.tableSet.loading = true
    },
    ['delete_order_tag_return']({ state, commit ,dispatch},payload) {
        state.specialOffer.tableSet.loading = false;
        if(payload.result.success){
            state.specialOffer.tableSet.resetFun();
            dispatch("response/success-tip", {message: payload.result.data},{root:true});
        }else{
            dispatch("response/error-tip", {message: payload.result.msg},{root:true});
        }
    },
    ['getList']({ state, commit ,dispatch},payload) {
        if (state.specialOffer.tableSet.loading == true) return;
        commit('clearList');
        commit('clearEntryList');
        let msg = {
            event: "command",
            data: {
                run: "read_so",  //需要获取的数据方法
                query: payload             //筛选查询条件
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        state.specialOffer.tableSet.loading = true
    },
    ['setList']({ state, commit ,dispatch},payload) {
        state.specialOffer.tableSet.loading = false;
        commit('setList',payload.result);
        if(isNotEmpty(payload?.result?.data?.data)){
            dispatch('getSoEntryList');
        }
    },
    ['getSoEntryList']({ state, commit ,dispatch},payload) {
        if (state.specialOffer.entryTableSet.loading == true) return;
        commit('clearEntryList');
        let msg = {
            event: "command",
            data: {
                run: state.specialOffer.tableSet.tab == 'xmxx' ? "read_so_entry" : "read_so_entry_price",  //需要获取的数据方法
                query:{
                    ID:state.specialOffer.tableSet.selected[0].id
                }
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        state.specialOffer.entryTableSet.loading = true
        state.specialOffer.priceTableSet.loading = true
    },
    ['setEntryList']({ state, commit ,dispatch},payload) {
        state.specialOffer.entryTableSet.loading = false;
        state.specialOffer.priceTableSet.loading = false;
        commit('setEntryList',payload.result);
    },
    ['setPriceList']({ state, commit ,dispatch},payload) {
        state.specialOffer.entryTableSet.loading = false;
        state.specialOffer.priceTableSet.loading = false;
        commit('setPriceList',payload.result);
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
